<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Gebruikers</h2>
    <button
      *appHasPermission="'user:create'"
      mat-button
      class="ml-auto"
      (click)="handleCreateUser()"
    >
      <mat-icon>add</mat-icon>

      Nieuwe gebruiker
    </button>
  </div>

  <div class="bg-white p-4 rounded-t-lg">
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        placeholder="Zoeken op ID of naam..."
        [disabled]="isSearchDisabled()"
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <app-data-table-container class="rounded-b-lg">
    <table
      mat-table
      matSort
      matSortDirection="asc"
      matSortActive="display_name"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="idAlias" sticky>
        <th mat-header-cell *matHeaderCellDef>Account ID</th>
        <td mat-cell *matCellDef="let element">
          {{ element.username }}
        </td>
      </ng-container>

      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="display_name">
          Weergavenaam
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="flex items-center gap-1">
            <span
              class="max-w-40 truncate"
              [matTooltip]="element.displayName"
              matTooltipPosition="after"
              >{{ element.displayName ?? '-' }}
            </span>
            @if (isSelf(element)) {
              <span class="text-xs text-gray-500 font-normal flex-none">(jij)</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rol</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex items-center gap-1">
            @if (element.userRoleName; as role) {
              <span
                class="bg-gray-300 text-gray-800 py-1 px-2 rounded-full text-xs font-medium"
                >{{ role }}</span
              >
            }

            @if (element.isSuperUser) {
              <span
                class="bg-linear-to-r from-indigo-200 to-violet-200 text-indigo-900 py-1 px-2 rounded-full text-xs font-medium"
                >Superuser</span
              >
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at">
          Aangemaakt op
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            *appHasPermission="['user:update', 'user:delete', 'user:move']"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button
              *appHasPermission="'user:update'"
              mat-menu-item
              (click)="handleEditUser(element)"
            >
              Bewerken
            </button>

            <button
              *appHasPermission="'user:update'"
              mat-menu-item
              (click)="handleResetPassword(element)"
            >
              Wachtwoord resetten
            </button>

            <button
              *appHasPermission="'user:move'"
              mat-menu-item
              [disabled]="isSelf(element)"
              (click)="handleMoveUser(element)"
            >
              Verplaatsen
            </button>

            <button
              *appHasPermission="'user:delete'"
              mat-menu-item
              [disabled]="isSelf(element)"
              (click)="handleDeleteUser(element)"
            >
              Verwijderen
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="hover:!bg-gray-100 whitespace-nowrap"
        (dblclick)="handleEditUser(row)"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
